<template>
  <v-container class="pa-0">
    <!-- nagłówek karty  -->
    <v-card class="mb-2">
      <v-card-title class="py-0 px-0">
        <v-card class="m0" color="primary" dark style="width: 100%">
          <v-card-title class="pt-0 pb-2 pl-2 pr-1">
            <span class="title font-weight-bold">{{
              $t("NewComplaint.TopicNewComplaint")
            }}</span>
            <v-spacer></v-spacer>
            <v-icon color="blue darken-1" @click="closeDialogNewComplaint()"
              >mdi-close
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="pb-0 pb-sm-2 pl-2">
            {{ $t("NewComplaint.TopicNewComplaintDescription") }}
          </v-card-subtitle>
        </v-card>
      </v-card-title>
    </v-card>

    <!-- Filtr wyszukiwania -->
    <v-card>
      <v-card-text v-if="showFilter" outlined class="pb-0 grey lighten-5">
        <v-row>
          <!-- Filtr: data od -->
          <v-col cols="6" sm="6" md="2" class="py-0">
            <v-menu
              v-model="menuStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="py-0 py-sm-1"
                  v-model="startDate"
                  :label="lblDateFrom"
                  append-icon="mdi-calendar"
                  @click:append="menuStartDate = true"
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>

              <v-date-picker
                v-model="startDate"
                :locale="lang"
                @input="menuStartDate = false"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- Filtr: data do -->
          <v-col cols="6" sm="6" md="2" class="py-0">
            <v-menu
              v-model="menuEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="py-0 py-sm-1"
                  v-model="endDate"
                  :label="lblDateTo"
                  append-icon="mdi-calendar"
                  @click:append="menuEndDate = true"
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                :locale="lang"
                @input="menuEndDate = false"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- Filtr: Numer dokumentu -->
          <v-col cols="6" sm="3" md="2" class="py-0">
            <v-text-field
              class="py-0 py-sm-1"
              type="number"
              v-model="filterInvoiceNumber"
              :label="lblDocumentNumber"
              @keydown.enter="refreshDocList"
            >
            </v-text-field>
          </v-col>

          <!-- Filtr: Numer zlecenia -->
          <v-col cols="6" sm="3" md="2" class="py-0">
            <v-text-field
              class="py-0 py-sm-1"
              v-model="filterOrderNumber"
              :label="lblOrderNumber"
              @keydown.enter="refreshDocList"
            >
            </v-text-field>
          </v-col>

          <!-- Filtr: Numer zlecenia klienta-->
          <v-col cols="6" sm="4" md="2" class="py-0">
            <v-text-field
              class="py-0 py-sm-1"
              v-model="filterClientOrderNumber"
              :label="lblClientOrderNumber"
              @keydown.enter="refreshDocList"
            >
            </v-text-field>
          </v-col>

          <!-- Filtr: Przycisk 'Odswież' -->
          <v-col
            cols="6"
            sm="2"
            md="2"
            class="py-0 text-sm-md-center text-right"
          >
            <v-btn
              class="mb-2 mt-sm-1"
              dark
              color="green"
              @click="refreshDocList()"
              @keydown.enter="refreshDocList"
              :loading="loading"
            >
              {{ $t("Refresh") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Ukrywanie filtra: odkryty -->
      <v-card-text
        v-if="showFilter"
        class="px-4 pt-0 pb-2 grey lighten-5 d-flex justify-end"
      >
        <v-checkbox v-model="autoHideFilter" class="ma-0 pa-0" hide-details>
          <template v-slot:label messages:false>
            <div class="caption pr-2">
              {{ $t("Autohide") }}
            </div>

            <v-btn
              v-show="!autoHideFilter"
              @click="showFilter = !showFilter"
              x-small
              >{{ $t("HideFilter") }}
              <v-icon small>mdi-filter-minus-outline</v-icon>
            </v-btn>
          </template>
        </v-checkbox>
      </v-card-text>

      <!-- Pokazywanie filtra: ukryty -->
      <v-card-text class="px-4 pt-2 pb-2 grey lighten-5" align="right" v-else>
        <v-btn @click="showFilter = !showFilter" x-small>
          {{ $t("ShowFilter") }}
          <v-icon small>mdi-filter-plus-outline</v-icon>
        </v-btn>
      </v-card-text>

      <v-alert
        :value="alertGetData"
        dark
        type="info"
        transition="scale-transition"
      >
        {{ $t("Loading") }}
      </v-alert>
    </v-card>

    <!-- odczytane dane  -->
    <v-card-text class="pt-0 my-0" v-if="TransactionalDocumentsList.length > 0">
      <!-- pole wyszukiwania -->
      <v-text-field
        class="pt-0"
        v-model="search"
        append-icon="mdi-magnify"
        v-bind:label="lblSearch"
        click:row
        single-line
        hide-details
      ></v-text-field>
    </v-card-text>

    <v-card
      v-if="TransactionalDocumentsList.length > 0"
      v-model="activeTab"
      background-color="white"
      color="primary"
    >
      <!-- tabela transactional documents dla sm i wyżej -->
      <v-card v-if="$vuetify.breakpoint.smAndUp">
        <v-data-table
          :headers="headerTransactionalDokuments"
          :items="TransactionalDocumentsList"
          :search="search"
          class="elevation-1"
          @click:row="openDialogDocument"
          item-key="idx"
          :loading="loading"
          :loading-text="lblLoading"
          :sort-by="['documentNumber.id']"
          :sort-desc="[true]"
          hide-default-footer
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
        >
          <template v-slot:[`item.issueDate`]="{ item }">{{
            dateFormat(item.issueDate)
          }}</template>
          <template v-slot:[`item.hasComplaint`]="{ item }"
            ><v-icon v-if="item.hasComplaint == true"
              >mdi-hammer</v-icon
            ></template
          >
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
          ></v-pagination>
        </div>
      </v-card>

      <!-- Tabela transactional dla formatu telefonów -->
      <v-card v-else>
        <v-btn
          v-scroll="onScroll"
          v-show="showScroll"
          fab
          dark
          fixed
          bottom
          right
          color="red"
          @click="toTop"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
        <v-data-table
          :headers="headerTransactionalDokuments"
          :items="TransactionalDocumentsList"
          :search="search"
          class="elevation-1"
          @click:row="openDialogDocument"
          item-key="idx"
          :loading="loading"
          :loading-text="lblLoading"
          :sort-by="['documentNumber.id']"
          :sort-desc="[true]"
          hide-default-header
          dense
          hide-default-footer
          :items-per-page="TransactionalDocumentsList.length"
        >
          <template v-slot:[`item.issueDate`]="{ item }">{{
            dateFormat(item.issueDate)
          }}</template>
          <template v-slot:[`item.hasComplaint`]="{ item }"
            ><v-icon v-if="item.hasComplaint == true"
              >mdi-hammer</v-icon
            ></template
          >
        </v-data-table>
      </v-card>
    </v-card>

    <!-- Dialog SelectExternalDocument for binders-->
    <v-dialog
      v-if="ExternalDocumentsList != null"
      v-model="showDialogExternalDocuments"
      max-width="350px"
      scrollable
      hide-overlay
    >
      <v-card>
        <v-card-title class="pa-1">
          <v-col cols="12" class="pa-0">
            <v-card class="m0" color="primary" dark>
              <v-card-title class="pt-0 pb-2 pl-2 pr-1">
                <span class="title font-weight-bold">
                  {{ $t("NewComplaint.SelectExternalDocument") }}
                </span>
                <v-spacer></v-spacer>
                <v-icon
                  color="blue darken-1"
                  @click="closeDialogExternalDocuments()"
                  >mdi-close
                </v-icon>
              </v-card-title>
            </v-card>
          </v-col>
        </v-card-title>

        <v-card-text class="px-2">
          <!-- Table of positions -->
          <v-data-table
            v-model="selectedExternalDocuments"
            :headers="headerExternalDocuments"
            :items="ExternalDocumentsList"
            :single-select="false"
            item-key="documentFullName"
            hide-default-footer
            class="elevation-1"
            @click:row="openDialogExternalDocument"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog NewComplaint - positions list-->
    <v-dialog
      v-if="TransactionalDocument != null"
      v-model="showDialogNewComplaint"
      scrollable
      max-width="90%"
      @keydown.esc="closeDialogDocument()"
      tabindex="0"
    >
      <v-card class="flexcard" height="90vh">
        <v-card-title class="pa-1">
          <v-card color="primary" dark style="width: 100%">
            <v-card-title class="pt-0 pb-2 pl-2 pr-1">
              <span class="title font-weight-bold">
                {{ TransactionalDocument.documentNumber.documentFullName }}
              </span>
              <v-spacer></v-spacer>
              <v-icon color="blue darken-1" @click="closeDialogDocument()"
                >mdi-close
              </v-icon>
            </v-card-title>
            <v-card-subtitle class="pb-0 pb-sm-2 pl-2">
              {{ $t("NewComplaint.Positions.Description") }}
            </v-card-subtitle>
          </v-card>
        </v-card-title>

        <!-- Table of positions --- sm and up-->
        <v-card-text
          v-if="$vuetify.breakpoint.smAndUp"
          style="height: 50vh"
          class="px-2"
        >
          <v-data-table
            id="positions"
            v-model="selectedComplaintPositions"
            :headers="headerTransacionalPosition"
            :items="TransactionalDocument.elementsList"
            :single-select="false"
            item-key="position"
            show-select
            disable-pagination
            hide-default-footer
            :sort-by="['position']"
            :sort-desc="[false]"
            class="elevation-1"
            :toggle-select-all="false"
          >
            <template v-slot:[`item.article.code`]="{ item }">
              <p
                v-if="
                  selectedComplaintPositions.find((o) => o.idx === item.idx)
                "
                class="font-weight-regular mb-0 blue--text"
              >
                {{ item.article.code }}
              </p>
              <p v-else class="font-weight-regular mb-0">
                {{ item.article.code }}
              </p>
              <p class="font-weight-light font-italic mb-0">
                {{ item.article.name }}
              </p>
            </template>

            <template v-slot:[`item.complaintQuantity`]="{ item }">
              <p class="font-weight-regular mb-0">
                {{ item.complaintQuantity }} {{ item.article.unit }}
              </p>
            </template>

            <template v-slot:[`item.hasComplaint`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-if="item.hasComplaint" v-bind="attrs" v-on="on"
                    >mdi-hammer
                  </v-icon>
                </template>

                <v-list-item
                  two-line
                  v-for="(complaint, index) in item.complaintsDocumentsList"
                  :key="index"
                >
                  <v-list-item-content class="white--text">
                    <v-list-item-subtitle class="white--text">
                      {{ dateFormat(complaint.issueDate) }}
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      {{ complaint.complaintDocumentNumber.documentFullName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>

        <!--List of positions --- below sm -->
        <v-card-text v-else class="px-0" style="height: 90vh">
          <v-list two-line>
            <v-list-item-group
              v-model="selectedComplaintPositionsPhone"
              multiple
              active-class="blue--text"
            >
              <template
                v-for="(item, index) in TransactionalDocument.elementsList"
              >
                <v-list-item :key="item.idx">
                  <template v-slot:default="{}">
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.article.code"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        class="text--primary"
                        v-text="item.article.name"
                      ></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-list-item-action-text
                        v-text="`${item.quantity} ${item.article.unit}`"
                      ></v-list-item-action-text>

                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="item.hasComplaint"
                            small
                            v-bind="attrs"
                            v-on="on"
                            >mdi-hammer
                          </v-icon>
                        </template>

                        <v-list-item
                          two-line
                          v-for="(
                            complaint, index
                          ) in item.complaintsDocumentsList"
                          :key="index"
                        >
                          <v-list-item-content class="white--text">
                            <v-list-item-subtitle class="white--text">
                              {{ dateFormat(complaint.issueDate) }}
                            </v-list-item-subtitle>
                            <v-list-item-title>
                              {{
                                complaint.complaintDocumentNumber
                                  .documentFullName
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-tooltip>
                    </v-list-item-action>
                  </template>
                </v-list-item>
                <v-divider :key="index"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="btnCreateComplaintDisabled"
            color="green darken-1"
            block
            :dark="!btnCreateComplaintDisabled"
            @click="
              selectedComplaintPositions.length > 0
                ? btnCreateComplaint(selectedComplaintPositions)
                : btnCreateComplaint(selectedComplaintPositionsPhone)
            "
            >{{ $t("NewComplaint.Positions.NewComplaint") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog NewComplaintDetails -->
    <v-dialog
      v-model="showDialogNewComplaintDetails"
      scrollable
      max-width="90%"
      @keydown.esc="btnCloseComplaintDetails"
      open-on-hover
    >
      <v-card>
        <v-card-title class="pa-1">
          <v-card color="primary" dark style="width: 100%">
            <v-card-title class="pt-0 pb-2 pl-2 pr-1">
              <span class="title font-weight-bold">
                {{ $t("NewComplaint.Steps.TopicComplaintDetals") }}
              </span>
              <v-spacer></v-spacer>
              <v-icon color="blue darken-1" @click="btnCloseComplaintDetails"
                >mdi-close
              </v-icon>
            </v-card-title>
            <v-card-subtitle class="pb-0 pb-sm-2">
              {{ $t("NewComplaint.Steps.TopicComplaintDetalsDescription") }}
            </v-card-subtitle>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-stepper class="elevation-0" v-model="actualClaimStep" vertical>
            <!-- step 1 -->
            <v-stepper-step
              :complete="actualClaimStep > 1"
              step="1"
              editable
              class="pl-2 pl-sm-6 pb-2"
            >
              {{ $t("NewComplaint.Steps.1.ItemsOfComplaint") }}
              <small>{{
                $t("NewComplaint.Steps.1.ItemsOfComplaintDescription")
              }}</small>
            </v-stepper-step>
            <v-stepper-content step="1" class="pl-2 pl-sm-6">
              <v-card color="primary" dark>
                <v-data-table
                  :headers="headersNewComplaint"
                  :items="selectedComplaintPositions"
                  item-key="position"
                  hide-default-header
                  hide-default-footer
                  disable-sort
                  light
                >
                  <template
                    v-if="$vuetify.breakpoint.smAndUp"
                    v-slot:[`item.article.code`]="{ item }"
                  >
                    <p class="font-weight-regular mb-0 blue--text">
                      {{ item.article.code }}
                    </p>
                    <p class="font-weight-light font-italic mb-0">
                      {{ item.article.name }}
                    </p>
                  </template>

                  <!-- Edycja ilości pozycji reklamacji -->
                  <template v-slot:[`item.complaintQuantity`]="item">
                    <v-dialog
                      v-model="showEditQuantityDialog"
                      max-width="500px"
                    >
                      <v-card>
                        <v-card-text class="ma-0 pb-0">
                          <v-row>
                            <v-col cols="12" sm="8" md="8">
                              <v-text-field
                                disabled
                                v-model="editComplaint.articleCode"
                                :label="lblCode"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-form
                                ref="formQuantityEdit"
                                v-model="editQuantityValid"
                                lazy-validation
                              >
                                <v-text-field
                                  v-model="editComplaint.newComplaintQuantity"
                                  :label="lblAdvertisedQuantity"
                                  type="number"
                                  :rules="[
                                    () =>
                                      editComplaint.newComplaintQuantity <=
                                        editComplaint.Quantity ||
                                      $t(
                                        'Complaints.Steps.1.TheQuantityShouldBeInTheRange'
                                      ) +
                                        ' 1 - ' +
                                        `${item.item.quantity}`,
                                    () =>
                                      editComplaint.newComplaintQuantity > 0 ||
                                      $t(
                                        'Complaints.Steps.1.TheQuantityShouldBeInTheRange'
                                      ) +
                                        ' 1 - ' +
                                        `${item.item.quantity}`,
                                  ]"
                                ></v-text-field>
                              </v-form>
                            </v-col>
                          </v-row>
                        </v-card-text>

                        <v-card-actions class="pt-0">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closeDialogEditComplaintQuantity()"
                          >
                            <v-icon color="red">mdi-close</v-icon>
                          </v-btn>

                          <v-btn
                            color="blue darken-1"
                            text
                            @click="
                              saveDialogEditComplaintQuantity(
                                editComplaint.newComplaintQuantity
                              )
                            "
                            :disabled="!editQuantityValid"
                          >
                            <v-icon color="green">mdi-check</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>

                      <template v-slot:activator="{ on }">
                        {{ item.item.complaintQuantity }}
                        <v-icon
                          v-on="on"
                          small
                          class="ml-2"
                          @click="openDialogEditComplaintQuantity(item.item)"
                          >mdi-pencil</v-icon
                        >
                      </template>
                    </v-dialog>
                  </template>
                </v-data-table>
              </v-card>
            </v-stepper-content>

            <!-- Step 2 -->
            <v-stepper-step
              step="2"
              :rules="rules_NewComplaintStep2"
              editable
              class="pl-2 pl-sm-6 py-2"
            >
              {{ $t("NewComplaint.Steps.2.TopicDescriptionOfTheComplaint") }}
              <small>{{
                $t(
                  "NewComplaint.Steps.2.TopicDescriptionOfTheComplaintDescription"
                )
              }}</small>
            </v-stepper-step>
            <v-stepper-content step="2" class="pl-4 pl-sm-6">
              <v-card>
                <v-form
                  ref="FormStep2"
                  v-model="validate_NewComplaintStep2"
                  lazy-validation
                >
                  <v-card-text class="pl-0">
                    <v-select
                      :items="ComplaintExpectationTable"
                      item-value="idx"
                      name="expectation"
                      :label="lblComplaintRequest"
                      v-model="ComplaintRequirements.expectation"
                      item-text="codeTranslate"
                      :rules="rules_Expectation"
                    ></v-select>

                    <v-textarea
                      v-model="ComplaintRequirements.description"
                      :rules="rules_Description"
                      name="description"
                      required
                      :label="lblDescriptionOfTheComplaint"
                      :hint="lblDescriptionOfTheComplaintHint"
                      clearable
                      no-resize
                    ></v-textarea>
                  </v-card-text>
                </v-form>
              </v-card>
            </v-stepper-content>

            <!-- Step 3 -->
            <v-stepper-step
              step="3"
              :rules="rules_NewComplaintStep3"
              editable
              class="pl-2 pl-sm-6 py-2"
            >
              {{ $t("NewComplaint.Steps.3.TopicDescriptionAddress") }}
              <small>{{
                $t("NewComplaint.Steps.3.TopicDescriptionAddressDescription")
              }}</small>
            </v-stepper-step>
            <v-stepper-content step="3" class="pl-4 pl-sm-6">
              <v-card>
                <v-form
                  ref="FormStep3"
                  v-model="validate_NewComplaintStep3"
                  lazy-validation
                >
                  <v-card-text class="py-0 pl-0">
                    <v-checkbox
                      class="mt-3"
                      v-model="ComplaintTargetCustomerAdressWZ"
                      :label="lblInspectionAddressFromWZ"
                      dense
                    >
                    </v-checkbox>

                    <v-row class="py-0 my-0">
                      <v-col cols="12" class="py-0 pl-0">
                        <v-subheader>Kontakt</v-subheader>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="1" class="py-0"> </v-col>
                      <v-col cols="12" sm="11" class="py-0">
                        <v-text-field
                          class="pa-0"
                          v-model="ComplaintTargetCustomer.address.name1"
                          :counter="50"
                          :rules="rules_TargetCustomerName"
                          :label="lblInspectionAddressName"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                          required
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="1" class="py-0"> </v-col>
                      <v-col cols="12" sm="4" class="py-0">
                        <v-text-field
                          class="pa-0"
                          v-model="ComplaintTargetCustomer.address.phone1"
                          :counter="30"
                          :rules="rules_TargetCustomerTel"
                          :label="lblInspectionAddressPhone1"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" class="py-0">
                        <v-text-field
                          class="pa-0"
                          v-model="ComplaintTargetCustomer.address.phone2"
                          :counter="30"
                          :rules="rules_TargetCustomerTel"
                          :label="lblInspectionAddressPhone2"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" class="py-0">
                        <v-text-field
                          class="pa-0"
                          v-model="ComplaintTargetCustomer.address.email"
                          :counter="100"
                          label="E-mail"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-divider class="mt-3 mb-1"></v-divider>

                    <v-row>
                      <v-col cols="12" class="py-0 pl-0">
                        <v-subheader>Adres</v-subheader>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="1" class="py-0"> </v-col>
                      <v-col cols="12" sm="11" class="py-0">
                        <v-text-field
                          class="pa-0"
                          v-model="ComplaintTargetCustomer.address.street"
                          :counter="30"
                          :rules="rules_TargetCustomerStreet"
                          :label="lblInspectionAddressStreet"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="1" class="pb-0 pt-3"> </v-col>
                      <v-col cols="12" sm="5" class="pb-0 pt-2">
                        <v-text-field
                          class="pt-1"
                          v-model="ComplaintTargetCustomer.address.city"
                          :counter="30"
                          :rules="rules_TargetCustomerCity"
                          :label="lblInspectionAddressCity"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="8" sm="4" class="pb-0 pt-2">
                        <v-text-field
                          class="pt-1"
                          v-model="ComplaintTargetCustomer.address.postalCode"
                          :counter="10"
                          :rules="rules_TargetCustomerKod"
                          :label="lblInspectionAddressPCode"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" sm="2" class="pb-0 pt-0">
                        <v-select
                          v-model="ComplaintTargetCustomer.address.country"
                          :items="ComplaintTargetCustomerCountry"
                          :label="lblInspectionAddressCountry"
                          :rules="rules_RequiredField"
                          :disabled="ComplaintTargetCustomerAdressWZ"
                          required
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
              </v-card>
            </v-stepper-content>

            <!-- Step 4 -->
            <v-stepper-step
              :complete="actualClaimStep > 2"
              step="4"
              editable
              class="pl-2 pl-sm-6 pt-2 pb-2"
            >
              {{ $t("NewComplaint.Steps.4.TopicAttachments") }}
              <small>{{
                $t("NewComplaint.Steps.4.TopicAttachmentsDescription")
              }}</small>
            </v-stepper-step>
            <v-stepper-content step="4" class="pl-4 pl-sm-6">
              <v-row v-if="this.BinariesDataList[0] != null">
                <v-col v-for="n in BinariesDataList.length + 1" :key="n">
                  <div class="pa-2 ma-1" v-if="n - 1 < BinariesDataList.length">
                    <image-input v-model="BinariesDataList[n - 1]">
                      <v-card slot="activator">
                        <auto-rotate>
                          <v-img
                            v-if="BinariesDataList[n - 1].typeId == 859"
                            class="white--text align-end"
                            height="120"
                            max-width="120"
                            min-width="120"
                            src="../../assets/pdf.png"
                          ></v-img>
                          <v-img
                            v-else
                            class="white--text align-end"
                            height="120"
                            max-width="120"
                            min-width="120"
                            :src="BinariesDataList[n - 1].fileURL"
                          ></v-img>
                        </auto-rotate>
                      </v-card>
                    </image-input>
                    <v-btn
                      color="error"
                      class="d-flex justify-center pa-1 ma-auto"
                      text
                      @click="deleteImage(n - 1)"
                      >{{ $t("Delete") }}</v-btn
                    >
                  </div>
                  <div v-else>
                    <image-input
                      v-model="BinariesDataList[BinariesDataList.length]"
                    >
                      <v-card slot="activator">
                        <v-icon size="120">mdi-image-plus</v-icon>
                        <v-card-actions></v-card-actions>
                      </v-card>
                    </image-input>
                  </div>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col>
                  <div>
                    <image-input v-model="BinariesDataList[0]">
                      <v-card slot="activator">
                        <v-icon size="120">mdi-image-plus</v-icon>
                        <v-card-actions></v-card-actions>
                      </v-card>
                    </image-input>
                  </div>
                </v-col>
              </v-row>
            </v-stepper-content>

            <!-- Step 5 -->
            <v-stepper-step step="5" editable class="pl-2 pl-sm-6 py-2">
              {{ $t("NewComplaint.Steps.5.TopicComplaintSummary") }}
              <small>{{
                $t("NewComplaint.Steps.5.TopicComplaintSummaryDescription")
              }}</small>
            </v-stepper-step>
            <v-stepper-content step="5">
              <v-card elevation="0">
                <v-card outlined>
                  <v-row>
                    <v-col
                      class="col-12 col-sm-12 text-center text-sm-left mb-0 px-4 py-1"
                    >
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-subtitle class="overline mb-0">
                            {{ $t("NewComplaint.Steps.5.Positions") }}
                          </v-list-item-subtitle>
                          <v-data-table
                            :headers="headersNewComplaint"
                            :items="selectedComplaintPositions"
                            item-key="position"
                            hide-default-header
                            hide-default-footer
                            disable-sort
                            dense
                          >
                            <template
                              v-if="$vuetify.breakpoint.smAndUp"
                              v-slot:[`item.article.code`]="{ item }"
                            >
                              <p class="font-weight-regular mb-0 blue--text">
                                {{ item.article.code }}
                              </p>
                              <p class="font-weight-light font-italic mb-0">
                                {{ item.article.name }}
                              </p>
                            </template>

                            <template
                              v-slot:[`item.complaintQuantity`]="{ item }"
                            >
                              <p class="font-weight-regular mb-0">
                                {{ item.complaintQuantity }}
                                {{ item.article.unit }}
                              </p>
                            </template>
                          </v-data-table>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- <v-card class="ma-1" outlined>
                <v-card-title class="overline mb-0">Żądanie</v-card-title>
                <v-card-text>
                  {{ findExpectationName() }}
                </v-card-text>
              </v-card> -->
              </v-card>

              <!-- <v-card class="ma-1" outlined v-if="BinariesDataList.length >= 1">
              <v-card-title class="overline mb-0">Załączniki</v-card-title>
              <v-card-text>
                <v-list-item>
                  <v-list-item-content
                    v-for="(item, index) in BinariesDataList"
                    :key="index"
                  >
                    <v-list-item-title>file{{ index + 1 }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      BinariesDataList[index].imageFileName
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </v-card> -->

              <v-card outlined>
                <v-row>
                  <v-col class="py-2">
                    <v-card-title class="overline py-0">{{
                      $t("NewComplaint.Steps.5.Description")
                    }}</v-card-title>
                    <v-card-text>
                      {{
                        ComplaintRequirements.description
                          ? ComplaintRequirements.description
                          : $t("NewComplaint.Steps.5.NoDescription")
                      }}</v-card-text
                    >
                  </v-col>
                  <v-col class="py-2">
                    <v-card-title class="overline py-0">{{
                      $t("NewComplaint.Steps.5.Request")
                    }}</v-card-title>
                    <v-card-text> {{ findExpectationName() }}</v-card-text>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="NewComplaint.instalationAddress" class="py-2">
                    <v-card-title class="overline py-0">{{
                      $t("NewComplaint.Steps.2.InspectionAddress")
                    }}</v-card-title>
                    <v-card-text>{{
                      NewComplaint.instalationAddress
                    }}</v-card-text>
                  </v-col>
                  <v-col v-if="BinariesDataList.length >= 1" class="py-2">
                    <v-card-title class="overline py-0">{{
                      $t("NewComplaint.Steps.4.TopicAttachments")
                    }}</v-card-title>
                    <v-card-text>
                      {{ $t("NewComplaint.Steps.4.AttachmentsCount") }} :
                      {{ BinariesDataList.length }}
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="green darken-1"
            :disabled="!validate_NewComplaint"
            block
            :dark="validate_NewComplaint"
            @click="btnSendNewComplaint()"
            >{{ $t("Send") }}<v-icon right>mdi-send</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogConfirmSendCompliant" max-width="500px">
      <v-card>
        <v-card-title class="headline">{{
          $t("NewComplaint.Steps.ConfirmSendNewComplaint")
        }}</v-card-title>
        <v-card-text>
          <v-form ref="showDialogConfirmSendCompliant">
            <v-card-actions class="justify-center">
              <v-btn color="error" @click="btnCloseConfirmSendCompliant()"
                >{{ $t("No") }}
              </v-btn>
              <v-btn
                color="primary"
                :loading="btnSendConfirmSendCompliantLoading"
                @click="btnSendConfirmSendCompliant(selectedComplaintPositions)"
                >{{ $t("Yes") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
      text-align:center
      multi-line
    >
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import ImageInput from "@/components/Complaints/ImageInput";
import i18n from "../../i18n";

export default {
  data() {
    return {
      lang: i18n.locale,
      startDate: "",
      endDate: "",
      filterInvoiceNumber: "",
      filterOrderNumber: "",
      filterClientOrderNumber: "",
      menuStartDate: false,
      menuEndDate: false,

      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      newComplaintLists: true,
      activeTab: 0,
      showRealizationDescriptionFull: true,
      showEditQuantityDialog: false,

      editedIndex: -1,

      showFilter: true,
      autoHideFilter: false,
      alertGetData: false,

      BinariesDataList: [],

      headersNewComplaint: [
        {
          text: "Kod",
          align: "left",
          sortable: false,
          value: "article.code",
        },
        {
          text: "Szt.",
          value: "complaintQuantity",
          sortable: false,
        },
      ],

      NewComplaint: {
        mainCustomer: {
          address: {
            idx: null,
          },
          person: {
            idx: null,
          },
        },
        targetCustomer: {
          address: {
            name1: "",
            name2: "",
            name3: "",
            country: "",
            postalCode: "",
            street: "",
            street2: "",
            city: "",
            province: "",
            district: "",
            commune: "",
            phone1: "",
            phone2: "",
            email: "",
            idx: null,
          },
          person: {
            idx: null,
          },
        },
        issueDate: null,
        foreignDocument: null,
        confirm: null,
        description: null,
        attribute: null,
        instalationAddress: "",
        elementsList: [],
        binariesDataList: [],
        idx: null,
      },

      elementsList: {
        position: null,
        source: {
          idx: null,
        },
        sourceElement: {
          idx: null,
        },
        article: {
          idx: null,
        },
        quantity: null,
        expectation: {
          idx: null,
        },
        binariesDataList: [],
        foreignDocument: null,
        description: null,
        reason: null,
        userAction: null,
        idx: null,
      },

      binariesDataList: {
        position: null,
        code: null,
        name: null,
        description: null,
        extension: null,
        typeId: null,
        data: null,
        idx: null,
      },

      snack: false,
      snackColor: "",
      snackText: "",

      showDialogNewComplaint: false,
      showDialogNewComplaintDetails: false,
      showDialogConfirmSendCompliant: false,
      showDialogExternalDocuments: false,
      confirmSendCompliant: false,

      actualClaimStep: 1,
      showSelectPositions: false,
      hiddenFab: false,
      showScroll: false,

      search: "",
      loading: false,

      privileges: 0,

      ComplaintRequirements: {
        description: null,
        expectation: null,
        instalationAddress: null,
      },

      ComplaintTargetCustomerCountry: [
        "PL",
        "CZ",
        "SK",
        "DE",
        "IT",
        "FR",
        "RO",
        "RU",
        "HU",
        "GB",
        "BE",
      ],
      ComplaintTargetCustomerAdressWZ: false,

      ComplaintTargetCustomer: {
        name: null,
        address: {
          name1: "",
          name2: "",
          name3: "",
          country: "",
          postalCode: "",
          street: "",
          street2: "",
          city: "",
          province: "",
          district: "",
          commune: "",
          phone1: "",
          phone2: "",
          email: "",
          idx: null,
        },
      },

      TransactionalDocumentsListTemporary: [],
      TransactionalDocumentsList: [],
      ExternalDocumentsList: [],
      TransactionalDocument: null,
      ComplaintExpectationTable: [],

      selectedComplaintPositions: [],
      selectedComplaintPositionsPhone: [],
      selectedExternalDocuments: [],

      btnCreateComplaintDisabled: true,
      btnSendConfirmSendCompliantLoading: false,

      editQuantityValid: true,
      editComplaint: {
        articleCode: null,
        Quantity: null,
        newComplaintQuantity: null,
      },

      validate_NewComplaintStep2: true,
      validate_NewComplaintStep3: true,

      rules_NewComplaint: [
        () =>
          this.validate_NewComplaintStep2 ||
          this.$t("Rules.CheckRequiredFields"),
        () =>
          this.validate_NewComplaintStep3 ||
          this.$t("Rules.CheckRequiredFields"),
      ],

      rules_NewComplaintStep2: [
        () =>
          this.validate_NewComplaintStep2 ||
          this.$t("Rules.CheckRequiredFields"),
      ],

      rules_Description: [(v) => !!v || this.$t("Rules.RequiredField")],
      rules_Expectation: [(v) => !!v || this.$t("Rules.RequiredField")],

      rules_NewComplaintStep3: [
        () =>
          this.validate_NewComplaintStep3 ||
          this.$t("Rules.CheckRequiredFields"),
      ],

      rules_TargetCustomerName: [
        (v) => !!v || this.$t("Rules.RequiredField"),
        (v) => (v && v.length <= 50) || this.$t("Rules.MaxChr"),
      ],

      rules_TargetCustomerTel: [
        (v) => !!v || this.$t("Rules.RequiredField"),
        (v) => (v && v.length <= 30) || this.$t("Rules.MaxChr"),
      ],

      rules_TargetCustomerStreet: [
        (v) => !!v || this.$t("Rules.RequiredField"),
        (v) => (v && v.length <= 30) || this.$t("Rules.MaxChr"),
      ],

      rules_TargetCustomerCity: [
        (v) => !!v || this.$t("Rules.RequiredField"),
        (v) => (v && v.length <= 30) || this.$t("Rules.MaxChr"),
      ],

      rules_TargetCustomerKod: [
        (v) => !!v || this.$t("Rules.RequiredField"),
        (v) => v.length <= 10 || this.$t("Rules.MaxChr"),
      ],

      rules_TargetCustomerEmail: [
        (v) => v.length <= 100 || this.$t("Rules.Email"),
      ],

      rules_RequiredField: [(v) => !!v || this.$t("Rules.RequiredField")],
    };
  },
  components: {
    ImageInput: ImageInput,
  },
  beforeMount() {
    if (this.$cookies.isKey("TPstartDate") == true) {
      if (
        this.$cookies
          .get("TPstartDate")
          .constructor.toString()
          .indexOf("Date") > -1
      ) {
        this.startDate = this.$cookies.get("TPstartDate");
      } else {
        this.startDate = new Date().getFullYear() + "-01-01";
      }
    } else {
      this.startDate = new Date().getFullYear() + "-01-01";
      this.$cookies.set("TPstartDate", this.startDate);
    }
    if (this.$cookies.isKey("TPendDate") == true) {
      if (
        this.$cookies.get("TPendDate").constructor.toString().indexOf("Date") >
        -1
      ) {
        this.endDate = this.$cookies.get("TPendDate");
      } else {
        this.endDate = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      }
    } else {
      this.endDate = this.endDate = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-");
      this.$cookies.set("TPendDate", this.endDate);
    }
  },
  mounted() {
    window.addEventListener("orientationchange", this.handleOrientationChange);
  },

  computed: {
    validate_NewComplaint: function () {
      if (this.validate_NewComplaintStep2 && this.validate_NewComplaintStep3) {
        return true;
      } else {
        return false;
      }
    },

    getstartDate: function () {
      return this.startDate;
    },
    getendDate: function () {
      return this.endDate;
    },
    lblDateFrom: function () {
      return this.$t("NewComplaint.DateFrom");
    },
    lblDateTo: function () {
      return this.$t("NewComplaint.DateTo");
    },
    lblDocumentNumber: function () {
      return this.$t("NewComplaint.DocumentNumber");
    },
    lblOrderNumber: function () {
      return this.$t("NewComplaint.DocumentsList.OrderNumber");
    },
    lblClientOrderNumber: function () {
      return this.$t("NewComplaint.DocumentsList.ClientOrderNumber");
    },
    lblSearch: function () {
      return this.$t("Search");
    },
    lblLoading: function () {
      return this.$t("Loading");
    },
    lblCode: function () {
      return this.$t("NewComplaint.Steps.1.Code");
    },
    lblAdvertisedQuantity: function () {
      return this.$t("NewComplaint.Steps.1.AdvertisedQuantity");
    },
    lblComplaintRequest: function () {
      return this.$t("NewComplaint.Steps.2.ComplaintRequest");
    },
    lblDescriptionOfTheComplaint: function () {
      return this.$t("NewComplaint.Steps.2.DescriptionOfTheComplaint");
    },
    lblDescriptionOfTheComplaintHint: function () {
      return this.$t("NewComplaint.Steps.2.DescriptionOfTheComplaintHint");
    },
    lblInspectionAddress: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddress");
    },
    lblInspectionAddressHint: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressHint");
    },
    lblInspectionAddressFromWZ: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressFromWZ");
    },
    lblInspectionAddressName: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressName");
    },
    lblInspectionAddressPhone1: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressPhone1");
    },
    lblInspectionAddressPhone2: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressPhone2");
    },
    lblInspectionAddressStreet: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressStreet");
    },
    lblInspectionAddressCity: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressCity");
    },
    lblInspectionAddressPCode: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressPCode");
    },
    lblInspectionAddressCountry: function () {
      return this.$t("NewComplaint.Steps.3.InspectionAddressCountry");
    },

    newQuanityIsCorrect() {
      if (
        this.editQuantity.newQuantity > 0 &&
        this.editQuantity.newQuantity <= this.editQuantity.oldQuantity
      ) {
        return true;
      } else {
        return false;
      }
    },
    headerTransactionalDokuments() {
      return [
        {
          text: this.$t("NewComplaint.DocumentsList.Document"),
          align: "start",
          value: "documentNumber.documentFullName",
          class: ".d-sm-none .d-md-flex",
        },
        {
          text: this.$t("NewComplaint.DocumentsList.mainCustomer"),
          value: "mainCustomer.code",
          align: window.Store.getters.getPriviliges == 0 ? " d-none" : "",
        },
        {
          text: this.$t("NewComplaint.DocumentsList.OrderNumber"),
          value: "orderDocumentNumber.foreignDocument",
        },
        {
          text: this.$t("NewComplaint.DocumentsList.ClientOrderNumber"),
          value: "foreignDocument2",
        },
        {
          text: this.$t("NewComplaint.DocumentsList.DateOfIssue"),
          value: "issueDate",
        },
        {
          text: "Info",
          align: "center",
          value: "hasComplaint",
        },
      ];
    },
    headerTransacionalPosition() {
      return [
        {
          text: this.$t("NewComplaint.Positions.Code"),
          value: "article.code",
        },
        {
          text: this.$t("NewComplaint.Positions.Quanity"),
          align: "center",
          value: "complaintQuantity",
        },
        {
          text: "Info",
          align: "center",
          value: "hasComplaint",
        },
      ];
    },
    headerExternalDocuments() {
      return [
        {
          text: this.$t("NewComplaint.DocumentNumber"),
          value: "documentFullName",
        },
      ];
    },
  },

  methods: {
    handleOrientationChange() {
      const orientation = window.screen.orientation.type;
      if (orientation === "portrait-primary") {
        //portret mode
        if (this.selectedComplaintPositions.length > 0) {
          for (var i = 0; i < this.selectedComplaintPositions.length; i++) {
            this.selectedComplaintPositionsPhone.push(
              this.selectedComplaintPositions[i].position - 1
            );
          }
          this.selectedComplaintPositions.length = 0;
        }
      } else if (orientation === "landscape-primary") {
        // landscape mode
        if (this.selectedComplaintPositionsPhone.length > 0) {
          for (
            var j = 0;
            j < this.selectedComplaintPositionsPhone.length;
            j++
          ) {
            this.selectedComplaintPositions.push(
              this.TransactionalDocument.elementsList[
                this.selectedComplaintPositionsPhone[j]
              ]
            );
          }
          this.selectedComplaintPositionsPhone.length = 0;
        }
      }
    },

    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.showScroll = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    targetCustomerAdressRewrite() {},
    targetCustomerAdressClear() {
      this.ComplaintTargetCustomer.address.name1 = "";
      this.ComplaintTargetCustomer.address.name2 = "";
      this.ComplaintTargetCustomer.address.name3 = "";
      this.ComplaintTargetCustomer.address.phone1 = "";
      this.ComplaintTargetCustomer.address.phone2 = "";
      this.ComplaintTargetCustomer.address.email = "";
      this.ComplaintTargetCustomer.address.postalCode = "";
      this.ComplaintTargetCustomer.address.city = "";
      this.ComplaintTargetCustomer.address.street = "";
      this.ComplaintTargetCustomer.address.street2 = "";
      this.ComplaintTargetCustomer.address.country = "";
      this.ComplaintTargetCustomer.address.idx = null;
    },

    findExpectationName() {
      if (this.ComplaintExpectationTable != null) {
        var idx = this.ComplaintExpectationTable.findIndex(
          this.findExpectationIdx
        );
        if (idx != -1) {
          return this.ComplaintExpectationTable[idx].codeTranslate;
        } else return this.$t("NewComplaint.Steps.5.Transients");
      } else {
        return this.$t("NewComplaint.Steps.5.Transients");
      }
    },

    findExpectationIdx(expectation) {
      return expectation.idx == this.ComplaintRequirements.expectation;
    },

    refreshDocList() {
      this.$cookies.set("TPautoHideFilter", this.autoHideFilter);
      this.$cookies.set("TPstartDate", this.startDate);
      this.$cookies.set("TPendDate", this.endDate);

      var startDate = new Date(this.startDate);
      var endDate = new Date(this.endDate);

      if (
        this.filterInvoiceNumber == "" &&
        this.filterOrderNumber == "" &&
        this.filterClientOrderNumber == ""
      ) {
        this.snack = true;
        this.snackColor = "info";
        this.snackText = this.$t("NewComplaint.SearchError1");
      } else if (endDate < startDate) {
        this.snack = true;
        this.snackColor = "info";
        this.snackText = this.$t("NewComplaint.SearchError2");
      } else {
        this.refreshTransactionalDocumentsView();
      }
    },

    // Edycja ilości reklamacji
    openDialogEditComplaintQuantity(item) {
      this.editedIndex = this.selectedComplaintPositions.indexOf(item);
      this.editComplaint.articleCode = this.selectedComplaintPositions[
        this.editedIndex
      ].article.code;
      this.editComplaint.Quantity = this.selectedComplaintPositions[
        this.editedIndex
      ].quantity;
      this.editComplaint.newComplaintQuantity = this.selectedComplaintPositions[
        this.editedIndex
      ].complaintQuantity;
      this.showEditQuantityDialog = true;
    },

    saveDialogEditComplaintQuantity(newComplaintQuantity) {
      var ValidationAnswer = this.validateEditQuantity();
      if (this.editedIndex > -1 && ValidationAnswer) {
        this.selectedComplaintPositions[
          this.editedIndex
        ].complaintQuantity = newComplaintQuantity;
      }
      this.editComplaint.articleCode = null;
      this.editComplaint.Quantity = null;
      this.editComplaint.newComplaintQuantity = null;
      this.showEditQuantityDialog = false;
    },
    closeDialogEditComplaintQuantity() {
      this.editedIndex = null;
      this.editComplaint.articleCode = null;
      this.editComplaint.Quantity = null;
      this.editComplaint.newComplaintQuantity = null;
      this.showEditQuantityDialog = false;
    },
    // Tworzenie reklamacji
    btnCreateComplaint: function () {
      this.getComplainExpectation();
      this.editQuantityValid = true;
      this.BinariesDataList = [];
      this.actualClaimStep = 1;
      this.showDialogNewComplaint = false;
      this.showDialogConfirmSendCompliant = false;
      this.ComplaintTargetCustomerAdressWZ = false;
      this.targetCustomerAdressClear();
      this.showDialogNewComplaintDetails = true;
    },
    btnCloseComplaint() {
      this.showDialogNewComplaintDetails = false;
      this.ComplaintRequirements.description = null;
      this.ComplaintRequirements.expectation = null;
      this.ComplaintTargetCustomerAdressWZ = true;
      this.ComplaintTargetCustomerAdressWZ = false;
      this.NewComplaint.instalationAddress = "";
      this.NewComplaint.instalationAddressCheck = false;
      this.BinariesDataList = [];
      this.showDialogNewComplaint = true;
      this.showDialogConfirmSendCompliant = false;
      this.showDialogNewComplaintDetails = false;
    },
    btnCloseComplaintDetails() {
      this.ComplaintRequirements.description = null;
      this.ComplaintRequirements.expectation = null;
      this.ComplaintTargetCustomerAdressWZ = false;
      this.NewComplaint.instalationAddress = "";
      this.NewComplaint.instalationAddressCheck = false;
      this.BinariesDataList = [];
      this.showDialogNewComplaint = true;
      this.showDialogNewComplaintDetails = false;
      this.$refs.FormStep2.resetValidation();
      this.$refs.FormStep3.resetValidation();
      this.targetCustomerAdressClear();
      // this.validate_NewComplaint = true;
      this.btnCreateComplaintDisabled = false;
      this.actualClaimStep = 1;
    },
    closeCompliaint() {
      this.showDialogNewComplaintDetails = false;
      this.ComplaintRequirements.description = null;
      this.ComplaintRequirements.expectation = null;
      this.ComplaintTargetCustomerAdressWZ = false;

      // this.validate_NewComplaint = true;
      this.NewComplaint.instalationAddress = "";
      this.NewComplaint.instalationAddressCheck = false;
      this.BinariesDataList = [];
      this.showDialogNewComplaint = false;
      this.showDialogConfirmSendCompliant = false;
      this.showDialogNewComplaintDetails = false;
      this.$router.push("/");
    },
    btnSendNewComplaint() {
      var ValidationAnswer = this.validateNewComplaint();
      if (ValidationAnswer) {
        this.showDialogConfirmSendCompliant = true;
      }
    },
    btnCloseConfirmSendCompliant() {
      this.btnSendConfirmSendCompliantLoading = false;
      this.ConfirmSendCompliant = false;
      this.showDialogConfirmSendCompliant = false;
    },
    btnSendConfirmSendCompliant(positions) {
      this.btnSendConfirmSendCompliantLoading = true;
      this.ConfirmSendCompliant = true;
      const binariesDataList = [];
      this.BinariesDataList.forEach((item) => {
        var binariesData = {
          code: item.fileName,
          name: item.fileName,
          description: item.fileName,
          extension: item.fileExtension,
          typeId: item.typeId,
          data: item.fileData,
        };
        binariesDataList.push(binariesData);
      });

      const elementsList = [];
      positions.forEach((item) => {
        var newElementsList = {
          position: item.position,
          source: {
            idx: this.TransactionalDocument.idx,
          },
          sourceElement: {
            idx: item.idx,
          },
          article: {
            idx: item.article.idx,
          },
          quantity: item.complaintQuantity,
          expectation: {
            idx: this.ComplaintRequirements.expectation,
          },
          foreignDocument: this.TransactionalDocument.foreignDocument,
          description: "",
          reason: this.ComplaintRequirements.description,
          //binariesDataList: binariesDataList,
        };
        elementsList.push(newElementsList);
      });

      this.NewComplaint.mainCustomer.address.idx = this.TransactionalDocument.mainCustomer.address.idx;
      this.NewComplaint.mainCustomer.person.idx =
        window.Store.getters.getCurrentUserIdx;

      this.NewComplaint.targetCustomer.address.idx = this.ComplaintTargetCustomer.address.idx;

      this.NewComplaint.targetCustomer.address.name1 = this.ComplaintTargetCustomer.address.name1.substring(
        0,
        50
      );
      this.NewComplaint.targetCustomer.address.name2 = this.ComplaintTargetCustomer.address.name2;
      this.NewComplaint.targetCustomer.address.name3 = this.ComplaintTargetCustomer.address.name3;
      if (this.ComplaintTargetCustomer.address.country == null) {
        this.NewComplaint.targetCustomer.address.country = "";
      } else {
        this.NewComplaint.targetCustomer.address.country = this.ComplaintTargetCustomer.address.country;
      }
      if (this.ComplaintTargetCustomer.address.postalCode == "") {
        this.NewComplaint.targetCustomer.address.postalCode = "0";
      } else {
        this.NewComplaint.targetCustomer.address.postalCode = this.ComplaintTargetCustomer.address.postalCode;
      }
      this.NewComplaint.targetCustomer.address.street = this.ComplaintTargetCustomer.address.street;
      this.NewComplaint.targetCustomer.address.street2 = "";
      this.NewComplaint.targetCustomer.address.city = this.ComplaintTargetCustomer.address.city;
      this.NewComplaint.targetCustomer.address.province = "";
      this.NewComplaint.targetCustomer.address.district = "";
      this.NewComplaint.targetCustomer.address.commune = "";
      this.NewComplaint.targetCustomer.address.phone1 = this.ComplaintTargetCustomer.address.phone1;
      this.NewComplaint.targetCustomer.address.phone2 = this.ComplaintTargetCustomer.address.phone2;
      this.NewComplaint.targetCustomer.address.email = this.ComplaintTargetCustomer.address.email;

      this.NewComplaint.targetCustomer.person.idx =
        window.Store.getters.getCurrentUserIdx;
      this.NewComplaint.issueDate = new Date();
      this.NewComplaint.foreignDocument = this.TransactionalDocument.foreignDocument;
      const descriptionVUE = this.ComplaintRequirements.description;
      this.NewComplaint.description = descriptionVUE
        .split("\n")
        .join(String.fromCharCode(13) + String.fromCharCode(10));
      this.NewComplaint.instalationAddress = this.NewComplaint.instalationAddress.replace(
        /\n/g,
        " ,"
      );

      this.NewComplaint.confirm = false;

      this.NewComplaint.elementsList = elementsList;
      this.NewComplaint.binariesDataList = binariesDataList;
      this.postComplaintsDocuments(this.NewComplaint);
      // this.snack = true;
      // this.snackColor = "orange darken-2";
      // this.snackText = this.$t("NewComplaint.Steps.ComplaintSave");
    },

    // Okienko z pozycjami dokumentu
    async openDialogDocument(selected) {
      this.selectedComplaintPositions = [];
      this.selectedComplaintPositionsPhone = [];
      this.BinariesDataList = [];

      if (this.TransactionalDocumentsList.length > 500) {
        this.TransactionalDocumentsList = [];
        this.newComplaintLists = false;
      }

      await this.getTransactionalDocument(selected.idx);

      if (this.TransactionalDocument.childDocumentsList.length > 0) {
        this.ExternalDocumentsList = this.TransactionalDocument.childDocumentsList;
        this.showDialogExternalDocuments = true;
      } else {
        this.showDialogNewComplaint = true;
      }
    },
    async openDialogExternalDocument(selected) {
      this.showDialogExternalDocuments = false;
      this.selectedExternalDocuments = [];
      // console.log(selected.id);
      await this.getTransactionalDocument(selected.idx);
      this.showDialogNewComplaint = true;
    },
    closeDialogDocument() {
      this.showDialogNewComplaint = false;
      this.TransactionalDocument = null;
      this.selectedComplaintPositions = [];
      this.selectedComplaintPositionsPhone = [];
      this.BinariesDataList = [];
    },
    closeDialogExternalDocuments() {
      this.showDialogExternalDocuments = false;
      this.ExternalDocumentsList = [];
    },
    closeDialogNewComplaint() {
      this.selectedComplaintPositions = [];
      this.selectedComplaintPositionsPhone = [];
      this.showDialogNewComplaintDetails = false;
      this.ConfirmSendCompliant = false;
      this.$router.push("/");
    },
    validateEditQuantity() {
      if (this.$refs.formQuantityEdit.validate()) {
        return true;
      } else {
        this.editQuantityValid = false;
        return false;
      }
    },
    validateNewComplaint() {
      if (this.ComplaintTargetCustomerAdressWZ) {
        this.$refs.FormStep3.resetValidation();
        if (this.$refs.FormStep2.validate()) {
          this.btnCreateComplaintDisabled = false;
          this.snackbar = true;
          return true;
        } else {
          this.btnCreateComplaintDisabled = true;
          if (!this.$refs.FormStep2.validate())
            this.validate_NewComplaintStep2 = false;
          return false;
        }
      } else {
        if (
          this.$refs.FormStep2.validate() &&
          this.$refs.FormStep3.validate()
        ) {
          this.btnCreateComplaintDisabled = false;
          this.snackbar = true;
          return true;
        } else {
          this.btnCreateComplaintDisabled = true;
          if (!this.$refs.FormStep2.validate())
            this.validate_NewComplaintStep2 = false;
          if (!this.$refs.FormStep3.validate())
            this.validate_NewComplaintStep3 = false;
          return false;
        }
      }
    },

    deleteImage(n) {
      this.BinariesDataList.splice(n, 1);
    },
    uploadImage(n) {
      this.BinariesDataList[n].btnDelete = true;
    },
    dateFormat: function (date) {
      return date.slice(0, 10);
    },

    async refreshTransactionalDocumentsView() {
      this.alertGetData = true;
      this.loading = true;
      this.TransactionalDocumentsList = [];

      var Mask = {
        documentTypesList: [
          "ExternalRelease",
          "ExportExternalRelease",
          "SalesInvoice",
          "ExportSalesInvoice",
        ],
        startDate: this.getstartDate,
        endDate: this.getendDate,
        status: "Confirmed",
      };

      if (this.filterInvoiceNumber != "") {
        Mask.documentNumber = this.filterInvoiceNumber;
      }
      if (this.filterOrderNumber != "") {
        Mask.orderForeignDocument = this.filterOrderNumber;
      }
      if (this.filterClientOrderNumber != "") {
        Mask.productionForeignDocument = this.filterClientOrderNumber;
      }

      await this.getTransactionalDocumentsView(Mask);
      // var Mask = {
      //   transactionDocumentType: typ,
      //   startDate: this.getstartDate,
      //   endDate: this.getendDate,
      //   status: "Confirmed"
      // };
      // await this.getTransactionalDocumentsView(Mask);

      // //Eksport
      // Mask = {
      //       transactionDocumentTypes (typ == 'SalesInvoice' ? 'ExportSalesInvoice' : 'ExportExternalRelease'),
      //       startDate: this.getstartDate,
      //       endDate:this.getendDate,
      //       status: "Confirmed",
      // };
      // await this.getTransactionalDocumentsView(Mask);

      // //Filtruje dokumenty jakie się mają pokazać na gridzie
      // this.TransactionalDocumentsListTemporary.forEach(item => {

      //   if (item.documentType == "DokumentWZ" || item.documentType == "DokumentWZE" || item.documentType == "DokumentFS" || item.documentType == "DokumentFSE") {
      //       var tmpInvoiceNumber = item.foreignDocument;
      //       var tmpOrderNumber = "";
      //       if (item.orderDocumentNumber != null){
      //         tmpOrderNumber = item.orderDocumentNumber.foreignDocument;
      //       }

      //       if (this.filterInvoiceNumber != "" && this.filterOrderNumber !="") {
      //         if (tmpInvoiceNumber.includes(this.filterInvoiceNumber) && tmpOrderNumber.includes(this.filterOrderNumber)) {
      //           this.TransactionalDocumentsList.push(item);
      //         }
      //       }
      //       else if (this.filterInvoiceNumber != "" && this.filterOrderNumber =="") {
      //         if (tmpInvoiceNumber.includes(this.filterInvoiceNumber)) {
      //           this.TransactionalDocumentsList.push(item);
      //         }
      //       }
      //       else if (this.filterInvoiceNumber == "" && this.filterOrderNumber !="" && this.filterOrderNumber !=null) {
      //         if (tmpOrderNumber.includes(this.filterOrderNumber)) {
      //           this.TransactionalDocumentsList.push(item);
      //         }
      //       }
      //       else
      //       {
      //         this.TransactionalDocumentsList.push(item);
      //       }
      //   }
      // });
      // this.TransactionalDocumentsListTemporary =[];

      if (this.autoHideFilter) {
        this.showFilter = false;
      }
      this.loading = false;
      this.alertGetData = false;
    },

    //API - pobieranie listy Dokumentów
    async getTransactionalDocumentsView(Mask) {
      return new Promise((resolve, reject) => {
        window.Store.dispatch("sessionAuthorise").then((response) => {
          if (response.respond == "logged") {
            axios
              .post(
                window.API.TransactionalDocumentsView,
                Mask,
                window.Store.getters.getAxiosHeader
              )
              .then((response) => {
                this.TransactionalDocumentsList = response.data;
                // this.TransactionalDocumentsListTemporary = [...this.TransactionalDocumentsListTemporary, ...response.data];
                if (this.TransactionalDocumentsList.length == 0) {
                  this.snack = true;
                  this.snackColor = "info";
                  this.snackText = this.$t("NewComplaint.NoData");
                }
                resolve();
              })
              .catch((errors) => {
                const errorStatus = errors.response;
                if (errorStatus == 401) {
                  window.Store.dispatch("logout");
                }
                reject(errors);
              });
          } else {
            window.Store.dispatch("logout");
          }
        });
      });
    },

    //API - pobieranie dokumentu
    async getTransactionalDocument(idx) {
      return new Promise((resolve, reject) => {
        // console.log(idx);
        window.Store.dispatch("sessionAuthorise").then((response) => {
          if (response.respond == "logged") {
            axios
              .get(
                window.API.TransactionalDocument + "/" + idx + "/" + window.Store.getters.getLang,
                window.Store.getters.getAxiosHeader
              )
              .then((response) => {
                this.TransactionalDocument = response.data;
                if (this.TransactionalDocument.elementsList != null) {
                  this.TransactionalDocument.elementsList.forEach((item) => {
                    item.complaintQuantity = item.quantity;
                    item.hasComplaint =
                      item.complaintsDocumentsList.length > 0 ? true : false;
                  });
                }
                resolve();
              })
              .catch((errors) => {
                const errorStatus = errors.response;

                if (errorStatus == 401) {
                  window.Store.dispatch("logout");
                }
                reject(errors);
              });
          } else {
            window.Store.dispatch("logout");
          }
        });
      });
    },
    //API - pobieranie listy żądań reklamacyjnych
    async getComplainExpectation() {
      window.Store.dispatch("sessionAuthorise").then((response) => {
        if (response.respond == "logged") {
          axios
            .get(
              window.API.ComplaintExpectation,
              window.Store.getters.getAxiosHeader
            )
            .then((response) => {
              this.ComplaintExpectationTable = response.data;
              this.ComplaintExpectationTable.forEach((item) => {
                item.codeTranslate = this.$t(item.code);
              });
            })
            .catch((errors) => {
              const errorStatus = errors.response;
              if (errorStatus == 401) {
                window.Store.dispatch("logout");
              }
            });
        } else {
          window.Store.dispatch("logout");
        }
      });
    },

    //API - wysyłanie nowej reklamacji
    async postComplaintsDocuments(NewComplaint) {
      window.Store.dispatch("sessionAuthorise").then((response) => {
        if (response.respond == "logged") {
          axios
            .post(
              window.API.ComplaintsDocuments,
              NewComplaint,
              window.Store.getters.getAxiosHeader
            )
            .then((response) => {
              const r = response.data;
              this.snack = true;
              this.snackColor = "success";
              
              this.snackText = this.$t("NewComplaint.Steps.ComplaintSuccesfullyCreated")
              this.snackText = this.snackText + " RLS-" + r.number + "/" + r.year.toString().substring(2) + "/" + r.month;

              setTimeout(() => this.closeCompliaint(), 2000);
            })
            .catch((errors) => {
              const errorStatus = errors.response;
              this.snack = true;
              this.snackColor = "error";
              this.snackText = this.$t(
                "NewComplaint.Steps.ComplaintErrorCreated"
              );
              this.btnSendConfirmSendCompliantLoading = false;
              this.showDialogConfirmSendCompliant = false;

              if (errorStatus == 401) {
                window.Store.dispatch("logout");
              }
            });
        } else {
          window.Store.dispatch("logout");
        }
      });
    },
  },
  watch: {
    selectedComplaintPositionsPhone() {
      if (this.selectedComplaintPositionsPhone.length > 0) {
        this.btnCreateComplaintDisabled = false;
      } else {
        this.btnCreateComplaintDisabled = true;
      }
    },

    selectedComplaintPositions() {
      if (this.selectedComplaintPositions.length > 0) {
        this.btnCreateComplaintDisabled = false;
      } else {
        this.btnCreateComplaintDisabled = true;
      }
    },

    ComplaintTargetCustomerAdressWZ(val) {
      if (val) {
        this.ComplaintTargetCustomer.address.name1 = this.TransactionalDocument.targetCustomer.name;
        this.ComplaintTargetCustomer.address.name2 = "";
        this.ComplaintTargetCustomer.address.name3 = "";
        this.ComplaintTargetCustomer.address.phone1 = this.TransactionalDocument.targetCustomer.address.phone1;
        this.ComplaintTargetCustomer.address.phone2 = this.TransactionalDocument.targetCustomer.address.phone2;
        this.ComplaintTargetCustomer.address.email = this.TransactionalDocument.targetCustomer.address.email;
        this.ComplaintTargetCustomer.address.postalCode = this.TransactionalDocument.targetCustomer.address.postcode;
        this.ComplaintTargetCustomer.address.city = this.TransactionalDocument.targetCustomer.address.city;
        this.ComplaintTargetCustomer.address.street = this.TransactionalDocument.targetCustomer.address.street;
        this.ComplaintTargetCustomer.address.street2 = "";
        this.ComplaintTargetCustomer.address.country = this.TransactionalDocument.targetCustomer.address.country;
        this.ComplaintTargetCustomer.address.idx = this.TransactionalDocument.targetCustomer.address.idx;
        this.validateNewComplaint();
        return true;
      } else {
        this.ComplaintTargetCustomer.address.name1 = "";
        this.ComplaintTargetCustomer.address.name2 = "";
        this.ComplaintTargetCustomer.address.name3 = "";
        this.ComplaintTargetCustomer.address.phone1 = "";
        this.ComplaintTargetCustomer.address.phone2 = "";
        this.ComplaintTargetCustomer.address.email = "";
        this.ComplaintTargetCustomer.address.postalCode = "";
        this.ComplaintTargetCustomer.address.city = "";
        this.ComplaintTargetCustomer.address.street = "";
        this.ComplaintTargetCustomer.address.street2 = "";
        this.ComplaintTargetCustomer.address.country = "";
        this.ComplaintTargetCustomer.address.idx = null;
        this.$refs.FormStep3.resetValidation();
        return false;
      }
    },

    showDialogNewComplaint(val) {
      if (!val && !this.showDialogNewComplaintDetails) {
        this.closeDialogDocument();
      }
    },
    showDialogNewComplaintDetails(val) {
      if (!val & !this.ConfirmSendCompliant) {
        this.showDialogNewComplaint = true;
        this.$refs.FormStep2.validate();
      }
    },

    showDialogConfirmSendCompliant(val) {
      if (!val && !this.ConfirmSendCompliant) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = this.$t("NewComplaint.Steps.CancelSendNewComplaint");

        this.dialogChangePassword = false;
        this.ConfirmSendCompliant = false;
        setTimeout(() => this.btnCloseConfirmSendCompliant(), 3000);
      }
    },
  },
};
</script>
